/** The browser's preferred languages, most preferred first (pages, workers and the SW). */
export const getDeviceLanguageTags = (): string[] => {
  if (typeof navigator === 'undefined') return []
  if (navigator.languages?.length) return [...navigator.languages]
  return navigator.language ? [navigator.language] : []
}
